import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, firstValueFrom, map, Subject, takeUntil, throwError } from 'rxjs';
import SignaturePad from 'signature_pad';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { VademecumActivity } from 'src/app/models/usuarios/vademecum-activity';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { UserActivityApiService } from 'src/app/service/api/user_activity-api.service';
import { environment } from 'src/environments/environment';
import packageJson from '../../../../../package.json';
import { list } from '@fitogest/reactive-form-builder/utils';
import { NavigationService } from 'src/app/service/navigation.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { ClienteModel } from 'src/app/models/cliente.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ClientesApiService } from 'src/app/service/api/clientes-api.service';
import { LoginApiService } from 'src/app/service/api/login-api.service';
import { MessageService } from 'primeng/api';
import { formatNativeDateAsDayMonthYear } from 'src/app/common/date-time-utils';
import { UploadApiService } from 'src/app/service/api/upload-api.service';
import { DropdownData, ReactiveFormStableValueChange } from '@fitogest/reactive-form-builder/interfaces';
import { setDropdownSelected } from '@fitogest/reactive-form-builder/utils';
import { FarmerOnboardingTourService } from 'src/app/service/tour/farmer-onboarding-tour.service';
import { NavbarProfileFormDefinition } from './form-control/navbar-profile-form-definition';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { ClientSelectionService } from 'src/app/service/client-selection.service';
import { UserModel } from 'src/app/models/usuarios/user.model';


interface ClientOption {
  label: string;
  value: string | null;
}

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {


  public logoUrl = environment.features.hasHorizontalLogo ?
        environment.logoUrl.replace(/(\.[a-z]+)$/, '_horizontal$1') :
        environment.logoUrl;

  public subscriptionStatusMessage = '';
  
  public subscriptionType = 'demo';

  readonly client_environment = environment;

  readonly productosApi = inject(ProductosApiService);

  readonly router = inject(Router);

  navigationService = inject(NavigationService);

  bo = inject(BreakpointObserver);

  readonly dashboardService = inject(DashboardService);

  private readonly loginService = inject(LoginApiService);

  private readonly clientsService = inject(ClientesApiService);

  private readonly clientSelectionService = inject(ClientSelectionService);

  private readonly http = inject(HttpClient);

  private readonly userActivityApi = inject(UserActivityApiService);

  private readonly destroy$ = new Subject<void>();

  private readonly messageService = inject(MessageService);

  private readonly uploadApi = inject(UploadApiService);

  private readonly farmerTourService = inject(FarmerOnboardingTourService);

  private readonly fincasApi = inject(FincasApiService);


  title = signal<string>('');

  hasSignature = signal<boolean>(false);

  actualizando = signal<boolean>(false);

  showClientProfile = signal(false);

  showModalProfile = computed(() => this.showClientProfile());

  showAdvertisingForm = false;

  showBackupDialog = false;

  showClientDialog = false;

  showVademecumActivity = false;

  showVademecumListadoProductos = false;

  showVademecumListadoDialog = false;

  showVademecumDialog = false;

  showUsuariosFirma = environment.features.showUsuariosFirma;

  showUsuariosLogs = environment.features.showUsuariosLogs;

  fechaEdited = false;

  isComunero = false;

  iconRefresh = 'fa fa-refresh';

  modelSignature = signal<string>('');

  private signatureChanged = false;

  textHeaderDialogClient = '';

  validationErrors = '';

  displayWizard = environment.features.welcomeWizard && StorageManager.getUser().wizard_done === 0;

  currentClient = StorageManager.getClient();

  userCanSeeClientes = environment.features.userCanSeeClientes
    ? true
    : StorageManager.getUser().rol === 'admin' ||
    StorageManager.getUser().rol === 'responsable';

  currentUser = StorageManager.getUser();

  urlSignature = environment.serverUrl + 'firmas_usuarios/' + (StorageManager.getUser().id || 0) + '.png';

  fincas: DropdownData<FincasModel> = list<FincasModel>(['...', null]);

  public clientOptions: ClientOption[] = [{ label: 'Cargando...', value: null }];

  public selectedClientId: string | null = this.clientSelectionService.getClientId(this.currentClient);

  private readonly clientsById = new Map<string, ClienteModel>();

  labelBtnClient = '';

  unidades = list('Hectáreas', 'Hanegadas', 'Taullas');

  profileForm = new NavbarProfileFormDefinition(this.unidades, this.fincas);

  listadoProductos: {
    id?: null | string;
    referencias?: string;
    productos?: string[];
  } = {
      id: null,
      referencias: '',
      productos: [''],
    };

  userActivity: VademecumActivity[] = [];

  helpMenuItems = [
    {
      label: 'Tutorial general',
      icon: 'pi pi-compass',
      command: (): void => {
        this.farmerTourService.startGeneralTour();
      },
    },
    {
      label: 'Guía de esta pantalla',
      icon: 'pi pi-info-circle',
      command: (): void => {
        this.farmerTourService.startCurrentModuleTour();
      },
    },
    {
      label: 'Asistente de Bienvenida',
      icon: 'fa fa-help',
      command: (): void => {
        this.displayWizard = true;
      },
    },
    {
      label: 'Guía de la Autorización a Locatec',
      icon: 'fa fa-file',
      command: (): void => {
        window.open(
          'https://locatec.es/proyectos/fitogest/documentos_consulta/guia-subida-autorizacion.pdf',
          '_blank'
        );
      }
    },
  ];

  menuItems = [
    {
      label: 'Tutorial general',
      icon: 'pi pi-compass',
      command: (): void => {
        this.farmerTourService.startGeneralTour();
      },
    },
    {
      label: 'Guía de esta pantalla',
      icon: 'pi pi-info-circle',
      command: (): void => {
        this.farmerTourService.startCurrentModuleTour();
      },
    },
    {
      separator: true,
    },
    {
      label: 'Mi perfil',
      icon: 'fa fa-user',
      command: (): void => {
        console.log('click');
        
        this.showClientProfile.set(true);
        if (this.showUsuariosFirma) {
          void this.fetchSignature();
        }
      },
      visible:
        !!((environment.features.showPerfil && this.currentUser.rol === 'admin') ||
          environment.appName === 'agrogestSIEX' ||
          environment.features.applicationType === 'cropgest'),
    },

    {
      separator: true,
      visible: environment.features.showPerfil && this.currentUser.rol === 'admin',
    },

    {
      label: 'Consulta logs',
      icon: 'fa fa-file',
      command: (): void => {
        this.router.navigate(['/dashboard/colsultas-logs']);
      },
      visible: environment.features.showUsuariosLogs,
    },

    {
      label: 'Publicidad',
      icon: 'fa fa-paper-plane',
      command: (): void => {
        this.showAdvertisingForm = true;
      },
      visible: this.currentUser.rol === 'admin' && environment.appName === 'agroleza',
    },
    {
      label:
        environment.features.applicationType === 'cropgest'
          ? 'Descargar datos'
          : 'Copia de seguridad',
      icon: 'fa fa-download',
      command: (): void => {
        this.showBackupDialog = true;
      },
      visible:
        environment.features.showBackup &&
        ((environment.features.applicationType !== 'cropgest' &&
          this.currentUser.rol === 'admin') ||
          (environment.features.applicationType === 'cropgest' &&
            this.currentUser.tipo === 'comunero')),
    },
    {
      label: 'Sincronizar datos',
      icon: this.iconRefresh,
      command: (): void => {
        this.initSyncDataCoop();
      },
      visible: environment.appName === 'almassora',
    },
    {
      separator: true,
      visible: environment.features.showBackup && this.currentUser.rol === 'admin',
    },
    {
      label: 'Actividad',
      icon: 'fa fa-list-alt',
      command: (): void => {
        this.showVademecumDialog = true;
        this.getVademecumActivity();
      },
      visible: this.showVademecumActivity && this.currentUser.rol === 'admin',
    },
    {
      separator: true,
      visible: this.showVademecumActivity && this.currentUser.rol === 'admin',
    },
    {
      label: 'Mis productos',
      icon: 'fa fa-flask',
      command: (): void => {
        this.productosApi.listadoVademecum.GET.response((res) => {
          if ((res?.[0]?.id) != null) {
            this.listadoProductos = res[0];
            this.listadoProductos.productos = (res[0].referencias ?? '').split(
              ';'
            );
          }
        });
        this.productosApi.listadoVademecum.GET.safePerform({
          id_usuario: StorageManager.getUser().id,
        } as never);
        this.showVademecumListadoDialog = true;
      },
      visible:
        this.showVademecumListadoProductos && this.currentUser.rol === 'admin',
    },
    {
      separator: true,
      visible:
        this.showVademecumListadoProductos && this.currentUser.rol === 'admin',
    },
    {
      label: 'Cerrar sesión',
      icon: 'fa fa-sign-out',
      command: (): void => {
        StorageManager.deleteUser();
        StorageManager.deleteClient();
        this.router.navigate(['login']);
      },
    },
    {
      label: `Version: ${packageJson.version}`,
      icon: 'fa fa-code-fork',
    },
  ];


  constructor() {
    // Observa cambios en los breakpoints y actualiza el servicio.
    this.bo.observe([
      Breakpoints.Handset,
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape
    ]).subscribe(state => {
      this.navigationService.isMobile.set(state.matches);
      this.navigationService.sidebarCollapsed.set(false);
      console.log('Maches [Mobile]:', state.matches);
      
    });

    this.bo.observe([
      Breakpoints.Tablet,
      Breakpoints.TabletPortrait,
      Breakpoints.TabletLandscape
    ]).subscribe(state => {
      this.navigationService.isTablet.set(state.matches);
      this.navigationService.sidebarCollapsed.set(false);
      console.log('Maches [Tablet]:', state.matches);
    });

    this.bo.observe([
      Breakpoints.Web,
      Breakpoints.WebLandscape,
      Breakpoints.WebPortrait
    ]).subscribe(state => {
      this.navigationService.isDesktop.set(state.matches);
      console.log('Maches [Desktop]:', state.matches);
    });

    this.bo.observe([
      Breakpoints.Handset,
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.Tablet,
      Breakpoints.TabletPortrait,
      Breakpoints.TabletLandscape
    ]).subscribe(state => {
      this.navigationService.isMobileOrTablet.set(state.matches);
      this.navigationService.sidebarCollapsed.set(false);
    });
  }


  ngOnInit(): void {
    if (environment.appName === 'agrogestSIEX') {
      this.daysUntilSubscriptionExpires();
    }
    this.initClients();

    if (environment.features.showPerfilFincas) {
      this.initFincas();
    }

    this.dashboardService.onChangeClient()
      .pipe(takeUntil(this.destroy$))
      .subscribe((): void => {
        this.applySelectedClient(this.clientSelectionService.syncFromStorage());

        if (environment.features.showPerfilFincas) {
          this.initFincas();
        }
      });

    this.dashboardService.onDialogChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((open: boolean): void => {
        if (open) {
          this.showClientDialog = true;
        } else {
          this.showClientDialog = false;
        }
      });

    this.dashboardService.onProfileChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((open: boolean): void => {
        if (open) {
          this.showClientProfile.set(true);
          void this.fetchSignature();
        } else {
          this.showClientProfile.set(false);
        }
      });

    if (environment.features.hasClients) {
      if (!(Boolean(StorageManager.getClient()))) {
        this.showClientDialog = environment.appName !== 'gruesnadal';
      }
    }

    if (environment.appName === 'gruesnadal') {
      const tablasMaestras = this.getModuleItem();
      
      tablasMaestras.forEach((tabla: any) => this.menuItems.push(tabla));
    }
  }

  toogleSidebar(): void {
    this.navigationService.sidebarCollapsed.set(!this.navigationService.sidebarCollapsed());
  }

  scrollToTop(): void {
    const elements = document.getElementsByClassName(
      'ui-dialog-content ui-widget-content'
    );

    const SCROLL_DELAY = 100;

    if (elements?.[0]) {
      setTimeout(() => {
        if (elements[0]) {
          elements[0].scrollTop = 0;
        }
      }, SCROLL_DELAY);
    }
  }

  showSignature(): void {
    const myWindow = window.open(
      'about:blank',
      '_blank',
      'width=600, height=600'
    );

    myWindow?.location.assign(
      environment.serverUrl + 'firmas_asesor/' + this.currentUser.firma
    );
    myWindow?.focus();
  }

  public updateClientById(): void {
    const selectedClientId = this.clientSelectionService.getClientId(this.selectedClientId);
    const selectedClient = selectedClientId === null ? null : this.clientsById.get(selectedClientId) ?? null;

    this.selectedClientId = selectedClientId;

    if (this.clientSelectionService.setSelectedClient(selectedClient)) {
      this.applySelectedClient(this.clientSelectionService.getSelectedClient());
    }
  }

  public getClientLabel(client: ClienteModel): string {
    const razonSocial = this.toNonEmptyString(client.razon_social);

    if (razonSocial !== null) {
      return razonSocial;
    }

    const nameParts = [client.nombre, client.apellidos, client.apellido_1, client.apellido_2]
      .map((value) => this.toNonEmptyString(value))
      .filter((value): value is string => value !== null);

    if (nameParts.length > 0) {
      return nameParts.join(' ');
    }

    const legacyName = this.toNonEmptyString(client['razon']) ?? this.toNonEmptyString(client['nomcli']);

    return legacyName ?? this.toNonEmptyString(client.id) ?? 'Cliente sin nombre';
  }

  drawComplete(sigpad: SignaturePad): void {
    this.modelSignature.set(sigpad.toDataURL('image/png'));
    this.signatureChanged = true;
  }

  clearSigPad(): void {
    this.modelSignature.set('');
    this.signatureChanged = true;
  }

  handleProfileValueChange(event: ReactiveFormStableValueChange<Record<string, unknown>>, source: 'user' | 'client'): void {
    const tag = String(event.changedField ?? '');

    if (source === 'client') {
      this.currentClient = { ...(this.currentClient ?? {}), ...event.value } as ClienteModel;
      return;
    }

    this.currentUser = { ...this.currentUser, ...event.value } as typeof this.currentUser;

    if (tag === 'uds_medida' && this.currentUser.uds_medida === 'Hectáreas') {
      this.currentUser.ratio_ha = 1;
    }

    if (tag === 'fecha_caducidad') {
      this.fechaEdited = true;
    }
  }

  validateForm(): boolean {
    this.validationErrors = '';

    // Sólo aplicar si el usuario tiene el campo `uds_medida` activo.
    if (environment.features.showPerfilUnidades) {
      if (
        this.currentUser.uds_medida !== 'Hectáreas' &&
        (this.currentUser.ratio_ha == null)
      ) {
        this.validationErrors +=
          '\n- Debe especificar la proporción de ' +
          this.currentUser.uds_medida +
          ' respecto a una Hectáreas.';
        return false;
      }
    }

    return true;
  }

  saveProfileEdit(): void {
    if (!this.validateForm()) {
      alert(this.validationErrors);
      return;
    }

    this.actualizando.set(true);

    const headers = new HttpHeaders();

    headers.append('Content-Type:', 'application/json');
    headers.append('Request-Method', 'PUT');

    if (this.isComunero) {
      delete this.currentClient?.tipo_carnet;

      firstValueFrom(
        this.http.put(
          `${environment.serverUrl}ws/index.php?p1=generic&p2=clientes&p3=${this.currentUser.id}`,
          JSON.stringify(this.currentClient),
          { headers: headers }
        )
      )
        .then(() => {
          this.clientSelectionService.setSelectedClient(this.currentClient, false);
          this.actualizando.set(false);
          this.showClientProfile.set(false);
          this.showSuccess();
          return;
        })
        .catch((e) => {
          console.log('catch en getPosition: ' + e);
        });
    } else {
      const selectedFinca = (this.currentUser as Record<string, unknown>)['id_finca'];

      if (selectedFinca && typeof selectedFinca === 'object') {
        (this.currentUser as Record<string, unknown>)['id_finca'] = Number((selectedFinca as Record<string, unknown>)['id'] ?? 0);
      }

      if (this.fechaEdited) {
        this.currentUser.fecha_caducidad = formatNativeDateAsDayMonthYear(this.currentUser.fecha_caducidad);
        this.fechaEdited = false;
      }

      delete this.currentUser['password'];

      firstValueFrom(
        this.http.put(
          `${environment.serverUrl}ws/index.php?p1=generic&p2=usuarios&p3=${this.currentUser.id}`,
          JSON.stringify(this.currentUser),
          { headers: headers }
        )
      )
        .then(async () => {
          await this.persistProfileSignatureIfNeeded();
          StorageManager.saveUser(this.currentUser);
          this.actualizando.set(false);
          this.showClientProfile.set(false);
          this.showSuccess();
          return;
        })
        .catch((e: unknown) => {
          this.actualizando.set(false);
          this.messageService.add({
            severity: 'error',
            summary: 'No se ha podido guardar el perfil',
            detail: e instanceof Error ? e.message : 'Revise la conexión e inténtelo de nuevo.',
          });
          console.error('Error saving profile:', e);
        });
    }
  }

  showSuccess(): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Perfil actualizado',
      detail: 'Se ha actualizado su perfil con éxito.',
    });
  }

  private daysUntilSubscriptionExpires(): void {
    const username = StorageManager.getUser().username ?? '';
     
    const subscriptionStatus = this.http
      .get<{ data: { tipo_suscripcion: string; subscription_status: string } }>(
        environment.serverUrl + 'ws/index.php?p1=user&p2=checkSubscriptionStatus',
        { params: { username } }
      )
      .pipe(
        map(response => ({
          remainingDays: response.data.subscription_status,
          tipo: response.data.tipo_suscripcion
        })),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );

    subscriptionStatus.subscribe(({ remainingDays, tipo }) => {
      this.subscriptionType = tipo;
      
      if (tipo !== null && tipo === 'demo') {
        if (remainingDays === 'expired') {
          this.subscriptionStatusMessage = 'El periodo de prueba ha expirado.';
        } else {
          this.subscriptionStatusMessage = 'El periodo de prueba termina en ' + remainingDays;
        }
      } else {
        if (remainingDays === 'expired') {
          this.subscriptionStatusMessage = 'La suscripción ha sido cancelada.';
        } else {
          this.subscriptionStatusMessage = 'La suscripción se renovará en ' + remainingDays;
        }
      }
    });

  }


  public shouldShowProfileSignature(): boolean {
    return environment.appName !== 'agrogestSIEX' && !this.isComunero;
  }

  private async persistProfileSignatureIfNeeded(): Promise<void> {
    if (!this.shouldShowProfileSignature() || !this.signatureChanged) {
      return;
    }

    const userId = String(this.currentUser.id ?? StorageManager.getUser().id ?? '').trim();

    if (userId === '') {
      throw new Error('No se puede guardar la firma porque el usuario no tiene ID.');
    }

    await this.uploadApi.firmasPOST.toPromise({
      id: userId,
      dir: 'firmas_usuarios',
      firma: this.modelSignature(),
    });

    this.signatureChanged = false;
  }

  private async fetchSignature(): Promise<void> {
    if (!this.shouldShowProfileSignature()) {
      this.hasSignature.set(false);
      this.modelSignature.set('');
      this.signatureChanged = false;
      return;
    }

    try {
      const resSignature = await fetch(`${this.urlSignature}?v=${Date.now()}`, { cache: 'no-store' });

      if (!resSignature.ok) {
        this.hasSignature.set(false);
        this.modelSignature.set('');
        this.signatureChanged = false;
        return;
      }

      const resBlob = await resSignature.blob();

      if (resBlob.size === 0) {
        this.hasSignature.set(false);
        this.modelSignature.set('');
        this.signatureChanged = false;
        return;
      }

      this.hasSignature.set(true);
      this.modelSignature.set(window.URL.createObjectURL(resBlob));
      this.signatureChanged = false;
    } catch (error: unknown) {
      this.hasSignature.set(false);
      this.modelSignature.set('');
      this.signatureChanged = false;
      console.warn('Could not load user signature:', error);
    }
  }


  private initFincas(): void {
    this.fincasApi.fincasGET.response((fincas) => {
      const options = fincas.map((finca: FincasModel) => ({
        label: finca.nombre ?? '',
        value: finca,
      }));

      this.fincas = {
        filtered: [{ label: '...', value: null }, ...options],
        values: options,
      };
      setDropdownSelected(
        this.fincas,
        fincas.find((finca: FincasModel) => +finca.id === this.currentUser.id_finca) ?? null
      );
      this.profileForm = new NavbarProfileFormDefinition(this.unidades, this.fincas);
    });
    this.fincasApi.fincasGET.safePerform();
  }

  private initClients(): void {
    this.applySelectedClient(this.clientSelectionService.syncFromStorage());

    const user = StorageManager.getUser();

    if (user.tipo === 'comunero' && this.currentClient === null) {
      this.clientsService.clientesGET
        .toPromise({ p3: user.id_cliente } as never)
        .then((clientes) => {
          const client = Array.isArray(clientes) ? clientes[0] ?? null : null;

          if (client !== null) {
            client.id_usuario = user.id;
            this.applyClientOptions([client], false);

            if (this.clientSelectionService.setSelectedClient(client)) {
              this.applySelectedClient(client);
            }
          }

          return;
        })
        .catch((error: unknown) => {
          console.error('Error loading comunero client:', error);
        });
      return;
    }

    this.clientsService.clientesGET.response((value) => {
      const clients = Array.isArray(value) ? value.filter((client): client is ClienteModel => client !== null) : [];
      const visibleClients = this.getVisibleClients(clients, user);
      const includeAllOption = this.shouldIncludeAllClientOption(user);

      this.applyClientOptions(visibleClients, includeAllOption);
      this.autoSelectClientIfNeeded(user);
    });
    this.clientsService.clientesGET.safePerform();
  }

  private applySelectedClient(client: ClienteModel | null): void {
    this.currentClient = client;
    this.selectedClientId = this.clientSelectionService.getClientId(client);
  }

  private getVisibleClients(clients: ClienteModel[], user: UserModel): ClienteModel[] {
    if (user.rol === 'admin' || user.rol === 'responsable' || environment.features.clientesMostrarTodosDefault) {
      return clients;
    }

    if (environment.appName === 'innovia') {
      return clients.filter((client) => this.clientSelectionService.sameClient(client, user.id_cliente));
    }

    return clients.filter((client) => [client.id_usuario_asignado, client.id_usuario_asignado2].includes(user.id));
  }

  private applyClientOptions(clients: ClienteModel[], includeAllOption: boolean): void {
    const clientOptions = this.buildClientOptions(clients);
    const allClientOption: ClientOption = {
      label: (environment.appName === 'detorres' ? 'TODAS LAS ' : 'TODOS LOS ') + environment.features.clientesName.toUpperCase(),
      value: null,
    };

    this.clientOptions = includeAllOption ? [allClientOption, ...clientOptions] : clientOptions;

    if (this.selectedClientId !== null && !this.clientsById.has(this.selectedClientId)) {
      this.applySelectedClient(null);
      this.clientSelectionService.setSelectedClient(null, false);
    }
  }

  private buildClientOptions(clients: ClienteModel[]): ClientOption[] {
    this.clientsById.clear();

    const options: ClientOption[] = [];

    clients.forEach((client) => {
      const clientId = this.clientSelectionService.getClientId(client);

      if (clientId === null) {
        return;
      }

      this.clientsById.set(clientId, client);
      options.push({
        label: this.getClientLabel(client),
        value: clientId,
      });
    });

    return options.sort((left, right) => left.label.localeCompare(right.label));
  }

  private shouldIncludeAllClientOption(user: UserModel): boolean {
    return !(user.rol === 'user' && (environment.appName === 'pascualcabedo' || environment.appName === 'innovia'));
  }

  private autoSelectClientIfNeeded(user: UserModel): void {
    if (this.shouldIncludeAllClientOption(user) || this.currentClient !== null) {
      return;
    }

    this.showClientDialog = false;

    const firstClientId = this.clientOptions.find((option) => option.value !== null)?.value ?? null;

    if (firstClientId === null) {
      return;
    }

    const firstClient = this.clientsById.get(firstClientId) ?? null;

    if (firstClient !== null && this.clientSelectionService.setSelectedClient(firstClient)) {
      this.applySelectedClient(firstClient);
    }
  }

  private toNonEmptyString(value: unknown): string | null {
    if (typeof value !== 'string' && typeof value !== 'number') {
      return null;
    }

    const text = String(value).trim();

    return text.length > 0 ? text : null;
  }

  private getModuleItem(): any {
    const modules = [
      {
        label: 'Albaranes',
        icon: 'bi bi-truck',
        command: (): void => {
          this.router.navigate(['dashboard/albaranes']);
        },
      },
    ];

    if (this.loginService.getCurrentUser().rol === 'admin') {
      modules.push(
        {
          label: 'Chofers',
          icon: 'bi bi-truck',
          command: (): void => {
            this.router.navigate(['dashboard/chofer']);
          },
        },
        {
          label: 'Clientes',
          icon: 'bi bi-person',
          command: (): void => {
            this.router.navigate(['dashboard/albaran-cliente']);
          },
        },
        {
          label: 'Maquinaria',
          icon: 'bi bi-tools',
          command: (): void => {
            this.router.navigate(['dashboard/albaran-maquinaria']);
          },
        },
        {
          label: 'Obras',
          icon: 'bi bi-cone',
          command: (): void => {
            this.router.navigate(['dashboard/obras']);
          },
        }
      );
    }

    return modules;
  }

  private initSyncDataCoop(): Promise<void> {
    this.iconRefresh = 'fa fa-refresh fa-spin';
    return firstValueFrom(
      this.http.get(environment.serverUrl + 'ws/sincro_inges/sincroniza.php')
    )
      .then((resp) => {
        console.log({ resp });

        alert('Se han actualizado los datos de clientes,fincas,parcelas');
        return;
      })
      .then(async () => {
        await firstValueFrom(
          this.http.get(
            environment.serverUrl +
            'ws/sincro_inges/tratamientos_fito_update.php'
          )
        );
        alert(
          'Se han actualizado los datos tareas fitosanitarias y tratamientos fitosanitarias'
        );
        this.iconRefresh = 'fa fa-refresh';
        return;
      })
      .catch(() => {
        console.log('Error en la conexión');
        this.iconRefresh = 'fa fa-refresh';
      });
  }

  private getVademecumActivity(): void {
    this.userActivityApi.vademecumActivityGET.safePerform();
    this.userActivityApi.vademecumActivityGET.response(
      (res: VademecumActivity[]) => {
        this.userActivity = res.reverse();
      }
    );
  }
      
  openDocumentInNewTab(): void {
    window.open('https://app.agrogest.com/#/register?estado=expired', '_blank');
  }
}
